import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "antd";
import { Col } from "antd";

const NewFeaturedSkelton = () => {
  return (
    <Fragment>
      {[1, 2, 3, 4].map((item, index) => (
        <Col
          className="gutter-row"
          xl={6}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          key={index}
        >
          <div className="card" style={{display:"flex"}}>
            <div className="rectangle">
              <Link>
                <div className="rectangle">
                  <Skeleton.Button
                    className="card-image"
                    active
                    style={{ width: "100%", height: "270px" }}
                  />
                </div>
              </Link>
            </div>
            <div className="frame-2">
              <div className="frame-3" style={{display:"flex", justifyContent:"flex-start"}}>
                <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "40%", marginBottom: 2 }}
                  active
                  size="small"
                  shape="round"
                />
                <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "40%", marginBottom: 2 }}
                  active
                  size="small"
                  shape="round"
                />
              </div>
              <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "310px", marginBottom: 2, marginTop: 5 }}
                  active
                  size="small"
                  shape="round"
                />
                <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "220px", marginBottom: 2, marginTop: 5 }}
                  active
                  size="small"
                  shape="round"
                />
                 <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "220px", marginBottom: 2, marginTop: 5 }}
                  active
                  shap="round"
                />
                <div className="frame-3" style={{display:"flex"}}>
                <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "100px", marginBottom: 2, marginTop: 20 }}
                  active
                  size="small"
                  shape="round"
                />
                <Skeleton.Input
                  paragraph={{ rows: 1 }}
                  style={{ width: "100px", marginBottom: 2, marginTop: 20 }}
                  active
                  size="small"
                  shape="round"
                />
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Fragment>
  );
};

export default NewFeaturedSkelton;
